
import ClassTypes from "./ClassTypes";
import {IndexSpec} from "./IndexSpec";
import Player from "../Player";
import Simulation from "../Simulation";

export default class ClassRegistry{
	static factories:any = {};
	static indexes:any = {};

	//This is used to store a mapping between classIds and real classNames from constructor.name;
	//For instance if we started off by creating CHAMPION:"Champion" in ClassTypes for the Champion Class
	//but then later changed the name of the class Champion to RiotChampion, we still want to be able to know that
	//the "Champion" type stored in our database should be linked to the RiotChampion object.
	static classNames:any = {};

	static registerFactory(type:string,factory:any){
		if(this.classNames[type] == undefined) this.classNames[type] = type;
		this.factories[type] = factory;
	}


	//Only use this if the string id in ClassTypes is not the same as the name of the actual class it references.
	static registerClassName(type:string, className:string){
		this.classNames[className] = type;
	}

	static registerIndex(type:string,spec:IndexSpec){

		//TODO check for duplicates
		if(this.indexes[type] == undefined){
			this.indexes[type] = [];
		}

		this.indexes[type].push(spec);

	}

	static getTypeFromClassName(className:string){
		return this.classNames[className];
	}

	static getIndexSpecs(type:string):IndexSpec[]{
		let specs = this.indexes[type];
		if(specs == undefined) return [];
		return specs;
	}

	static getFactory(type:string){
		if(this.factories[type] == undefined) throw new Error("NO FACTORY REGISTERED FOR " + type);
		return this.factories[type];
	}


}

//Champion
ClassRegistry.registerFactory(ClassTypes.PLAYER, ()=>new Player());
ClassRegistry.registerFactory(ClassTypes.SIMULATION, ()=> new Simulation());



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/framework/ClassRegistry.ts